module.exports = __webpack_public_path__ + "img/icones_oak-1.269c55fb.png";